<template>
  <FlexColumn :space="0">
    <Label text="現在の年収" class="mb-1" bold />
    <FlexRow>
      <SimpleSelectField
          placeholder="下限"
          :value="value.lower"
          :items="items"
          class="mt-0 pt-0"
          @input="handleLower"
      />
      <SimpleSelectField
          placeholder="上限"
          :value="value.upper"
          :items="items"
          class="mt-0 pt-0"
          @input="handleUpper"
      />
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexRow from "../atoms/FlexRow";
import SimpleSelectField from "../atoms/SimpleSelectField";
import FlexColumn from '../atoms/FlexColumn'
import Label from '../atoms/Label'

export default {
  name: "ApplicantSearchSalarySelect",
  components: { Label, FlexColumn, SimpleSelectField, FlexRow},
  props: {
    value: {
      type: Object
    }
  },
  computed: {
    items() {
      return [
        { value: null, label: "指定なし"},
        { value: 300, label: "300万"},
        { value: 350, label: "350万"},
        { value: 400, label: "400万"},
        { value: 450, label: "450万"},
        { value: 500, label: "500万"},
        { value: 550, label: "550万"},
        { value: 600, label: "600万"},
        { value: 650, label: "650万"},
        { value: 700, label: "700万"},
        { value: 800, label: "800万"},
        { value: 900, label: "900万"},
        { value: 1000, label: "1000万"},
        { value: 1100, label: "1100万"},
        { value: 1200, label: "1200万"},
        { value: 1500, label: "1500万"},
        { value: 2000, label: "2000万"},
      ]
    }
  },
  methods: {
    handleLower(value) {
      this.$emit("input", {
        lower: value || undefined,
        upper: this.value.upper
      })
    },
    handleUpper(value) {
      this.$emit("input", {
        lower: this.value.lower,
        upper: value || undefined
      })
    }
  }
}
</script>

<style scoped>

</style>